<div *ngFor="let data of statisticsSections | keyvalue: originalOrder" translate-namespace="filter">
    <section class="Flexbox Flexbox__box-direction-column Marginbox__b-tiny filter-section">
        <dls-expander class="filter-group fs6_5" [header]="data.key|translate" [expanded]="'true'">
            <div *ngFor="let filter of data.value.filters;" class="filter">
                <span class="filter-name">{{filter.translatedName}}</span>

                <div class="Flexbox" *ngIf="filter.config.statsType">
                    <gen-statistics-control [filter]="filter"
                                            class="Flexbox Flexbox__flex-1 statistics-control-container"></gen-statistics-control>
                </div>
                <div class="Flexbox Marginbox__t-tiny" *ngIf="!filter.config.statsType">
                    <gen-filter-input [filter]="filter" class="Flexbox Flexbox__flex-1"></gen-filter-input>
                </div>
            </div>
        </dls-expander>
    </section>
    `
</div>
